import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import * as fromFB from './../form-designer/fb-state/reducers/fb.reducer';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/data/models/app-state';
import { TreeNode } from 'app-models';
import { CreatePageFormService } from '../form-designer/create-page-form/create-page-form.service';
import { CustomButtonActionService } from 'custom-button-action';
import { FbModuleService } from './fb-module.service';
import * as FB from './../form-designer/fb-state/actions/fb.actions';
import { AuthenticationService } from 'authentication';
import { SwitchAppService } from '../shared/switch-app/switch-app.service';
import { environment } from 'src/environments/environment';

// const SESSION_KEYS = {
//   IS_FB_USER: 'isFBUser',
//   MODULE_ID: 'moduleId',
//   PAGE_FORM_ID: 'pageFormId',
//   PRESENT_MENU: 'presentMenu'
// };

@Component({
  selector: 'app-fb-module',
  templateUrl: './fb-module.component.html',
  styleUrls: ['./fb-module.component.scss']
})
export class FbModuleComponent implements OnInit {
  observableSubscription$ = new Subject();
  isFBModulePreview = false;
  navMenuItems: TreeNode[];
  preSelectedMenu: number;
  isFBUser: boolean;
  presentMenu: TreeNode;
  presentApp: string;
  appRoleData: any[];
  presentAppId: number;
  forMenuList: {
    moduleId: number,
    formBuilderInfo: any
  } = {
      moduleId: null,
      formBuilderInfo: null
    };

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private createPageFormService: CreatePageFormService,
    private customButtonActionService: CustomButtonActionService,
    private fbModuleService: FbModuleService,
    private authenticationService: AuthenticationService,
    private switchAppService: SwitchAppService
  ) {
    this.handleUserAuthentication();
  }

  private handleUserAuthentication(): void {
    const currentUser = sessionStorage.getItem('currentUser');
    if (currentUser) {
      this.authenticationService.validateUser(JSON.parse(currentUser).jwt)
        .pipe(take(1))
        .subscribe(response => {
          if (!(response?.status === 200)) {
            this.logoutAndRedirect();
          }
        });
      this.isFBUser = sessionStorage.getItem('isFBUser') === 'true';
    } else {
      this.logoutAndRedirect();
    }
  }

  private logoutAndRedirect(): void {
    this.authenticationService.logout()
      .pipe(take(1))
      .subscribe(() => {
        this.authenticationService.clearUserData();
        this.router.navigate(['/login']);
      });
  }

  ngOnInit() {
    this.handleOnLoadMenuList();
    this.getAppRoleData();
    this.handleOnShowBeneficiaryProfile();
    this.checkFBModulePreview();
  }

  getAppRoleData() {
    const companyId = 'companyId' in sessionStorage && !isNaN(Number(sessionStorage.getItem('companyId'))) ? Number(sessionStorage.getItem('companyId')) : null;
    const employeeId = 'loginEmployeeId' in sessionStorage && !isNaN(Number(sessionStorage.getItem('loginEmployeeId'))) ? Number(sessionStorage.getItem('loginEmployeeId')) : null;
    if (companyId && employeeId) {
      this.switchAppService.getUserAppRoleDetails(companyId, employeeId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
        this.appRoleData = data ? data.appRoleDetails.map(x => {
          return {
            ...x,
            companyApp: {
              ...x.companyApp,
              iconImagePath: environment.docs + x.companyApp.iconImagePath.replace('/var/imagility/uploads/', '')
            }
          };
        }) : null;
        if ('presentApp' in sessionStorage) {
          this.presentApp = sessionStorage.getItem('presentApp');
          this.presentAppId = this.appRoleData.find(x => x.companyApp.appName === this.presentApp).companyApp.appId;
        } else {
          const companyApp = this.appRoleData.find(x => x.isUserDefaultApp).companyApp;
          this.presentApp = companyApp.appName;
          this.presentAppId = companyApp.appId;
          sessionStorage.setItem('presentApp', this.presentApp);
        }
        this.getMenuList();
      });
    }
  }

  private handleOnLoadMenuList(): void {
    this.fbModuleService.onLoadMenuList
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: {
        moduleId: number,
        formBuilderInfo: any
      }) => {
        this.forMenuList = { ...data };
        this.getMenuList();
      });
  }

  private handleOnShowBeneficiaryProfile(): void {
    this.customButtonActionService.onShowBeneficiaryProfile
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: {
        pageFrom: string,
        fbEmpId: number
      }) => {
        this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
        setTimeout(() => {
          this.router.navigate([`./employee/profile/education`], {
            queryParams: {
              pageFrom: data.pageFrom,
              fbEmpId: data.fbEmpId
            },
            relativeTo: this.route
          });
        }, 0);
      });
  }

  private checkFBModulePreview(): void {
    this.store.select(fromFB.getIsFBModulePreview)
      .pipe(take(1))
      .subscribe((response) => {
        this.isFBModulePreview = response;
        if (!this.isFBModulePreview && !this.isFBUser) {
          this.redirectBack();
        }
      });
  }

  getMenuList() {
    if (this.forMenuList.moduleId && (!this.isFBUser || (this.isFBUser && this.presentAppId))) {
      let req;
      if (this.isFBUser) {
        req = this.createPageFormService.getMenuWithPermissionListById(this.forMenuList.moduleId, this.presentAppId);
      } else {
        req = this.createPageFormService.getMenuListById(this.forMenuList.moduleId);
      }
      req
        .pipe(take(1))
        .subscribe((menuList: any[]) => {
          if (menuList?.length > 0) {
            // menuList.sort((a, b) => a.id - b.id);

            // to check if any orphan menu item exists.
            // const idSet = menuList.map(y => y.id);
            // const menuIdwithMissingParent = menuList.filter(x => x.parentMenuId && !(idSet
            //   .includes(x.parentMenuId)));
            // console.log(menuIdwithMissingParent);

            if (this.forMenuList.formBuilderInfo) {
              this.preSelectedMenu = this.forMenuList.formBuilderInfo.menuId;
              this.navMenuItems = this.buildChildNodes(menuList, null);
            } else {
              const navMenuItems = this.buildChildNodes(menuList, null);
              this.preSelectedMenu = this.findFirstMenu(navMenuItems);
              this.navMenuItems = navMenuItems;
            }
          } else {
            this.navMenuItems = []
          }
        });
    }
  }

  findFirstMenu(menuList: TreeNode[]) {
    let id: number = menuList[0].value;
    if (menuList[0].children && menuList[0].children.length > 0) {
      const navMenuItemsCopy = JSON.parse(JSON.stringify(menuList[0].children));
      id = this.findFirstMenu(navMenuItemsCopy);
    }
    return id;
  }

  buildChildNodes(tempResponse, parentMenuId) {
    const subList = tempResponse.filter(x => !parentMenuId ? !x.parentMenuId : x.parentMenuId === parentMenuId);
    if (subList && subList.length > 0) {
      return subList.map(x => {
        const childNodes = this.buildChildNodes(tempResponse, x.id);
        let returnObj: TreeNode = {
          label: x.menuOrSubMenuName,
          value: x.id,
          pageFormId: x.pageFormId ? x.pageFormId : null,
          formType: x.buildFormatTypeId ? x.buildFormatTypeId : null,
          customObj: { ...x }
        };
        if (childNodes && childNodes.length > 0) {
          returnObj = {
            ...returnObj,
            children: [...childNodes],
            showChildren: false
          };
        }
        return returnObj;
      });
    }
    return subList;
  }

  redirectBack() {
    this.router.navigate(['../../platform-admin-landing/page-designer/manage-forms/created-forms'], { relativeTo: this.route });
  }

  onMenuClickPageOpen(item: TreeNode) {
    const keysToRemove = ['formDataId', 'FbEmployeeId', 'FbActualEmployeeId', 'idToGetDetails', 'fbFormDataDTO', 'redirectTabIndex', 'isButtonNew', 'getFilesId'];
    keysToRemove.forEach(key => {
      if (key in sessionStorage) {
        sessionStorage.removeItem(key);
      }
    });
    sessionStorage.setItem('selectedMenu', JSON.stringify(item));
    this.onPageOpen(item);
  }

  onPageOpen(item: TreeNode) {
    this.store.select(fromFB.getIsBeneFiciaryProfile)
      .pipe(take(1))
      .subscribe((response) => {
        if (response) {
          this.store.dispatch(new FB.SetIsBeneficiaryProfile(false));
          sessionStorage.setItem('presentMenu', JSON.stringify(item));
          if (location.href.includes('modules-landing/fb/module')) {
            this.fbModuleService.onPageOpenSubject.next(item);
          } else {
            this.router.navigate([`./module`], { relativeTo: this.route });
          }
        } else {
          this.fbModuleService.onPageOpenSubject.next(item);
        }
      });
  }

  ngOnDestroy() {
    const keysToRemove = ['fbEditFormDataDTO', 'fbFormDataDTO'];
    keysToRemove.forEach(key => {
      if (key in sessionStorage) {
        sessionStorage.removeItem(key);
      }
    });
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // this.clearSessionData();
  }

  // private clearSessionData(): void {
  //   Object.values(SESSION_KEYS).forEach(key => {
  //     sessionStorage.removeItem(key);
  //   });
  // }

}
